/* eslint-disable @typescript-eslint/member-ordering */

import { ChangeDetectionStrategy, Component, computed, inject, Signal, signal, WritableSignal } from '@angular/core';
import { PageHeaderComponent } from '@libs/common/components';
import { SkuSearchResultViewModel, QuickOrderSelectionModel, QuickOrderAddTab } from '@libs/shop/models';
import { QuickOrderService, ShoppingListsState } from '@libs/shared/services';
import { ProductTrackingListDirective } from '@libs/shared/tracking';
import { QuickOrderAddComponent } from './quick-order-add/quick-order-add.component';
import { QuickOrderProductListComponent } from './quick-order-product-list';

@Component({
  selector: 'ui-quick-order',
  imports: [PageHeaderComponent, QuickOrderAddComponent, QuickOrderProductListComponent, ProductTrackingListDirective],
  templateUrl: './quick-order.component.html',
  styleUrl: './quick-order.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class QuickOrderComponent {
  private readonly quickOrderService: QuickOrderService = inject(QuickOrderService);
  public readonly shoppingListState: ShoppingListsState = inject(ShoppingListsState);

  public productsToSelect: WritableSignal<QuickOrderSelectionModel[]> = signal<QuickOrderSelectionModel[]>([]);
  public missingProducts: WritableSignal<string[]> = signal([]);
  public loading: WritableSignal<boolean> = signal(false);
  public quickOrderListId: Signal<string> = computed(() => this.quickOrderService.determineQuickOrderShoppingListId());
  public activeTab: WritableSignal<QuickOrderAddTab> = signal('quickorder');

  public async onProductsAdded(productIdentifiers: Record<string, number>): Promise<void> {
    this.loading.set(true);
    const parseSkuResult: SkuSearchResultViewModel = await this.quickOrderService.getSkuSearchResultViewModel(productIdentifiers);

    if (Object.keys(parseSkuResult.singleResultItems).length) {
      await this.quickOrderService.addToQuickOrderList(this.quickOrderListId(), parseSkuResult.singleResultItems);
    }

    if (parseSkuResult.multipleResultItems.length) {
      this.productsToSelect.set(await this.quickOrderService.getProductsToSelect(parseSkuResult.multipleResultItems));
    }

    this.missingProducts.set(parseSkuResult.notFoundItems);
    this.loading.set(false);
  }
}
